import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';

// Import Style
import '../style.scss';

class NaveAddonPage extends Component {
  render() {
    const { location } = this.props;
    const withHost = location && location.query && location.query.host
    const url = withHost ?
      `${withHost}/jira/marketplace/discover/app/com.getnave.jira?installDialogOpen=true&source=mpac` :
      'https://marketplace.atlassian.com/apps/1220667/kanban-analytics?tab=overview&hosting=cloud';

    return (
      <div className='main addon'>
        <section className='section'>
          <div className='container'>
            <h1>Oops, you don't have Nave yet</h1>
            <p>
              Nave helps software development teams continuously make process improvements to build better products faster through insightful analytics
            </p>
            <a target="_blank" href={url} className='btn btn-primary'>Get Nave</a>
          </div>
      	</section>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = state => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NaveAddonPage));
